import {AfterViewInit, Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {finalize} from 'rxjs/operators';

import {Proverb} from '../../models/proverb.model';
import {ProverbBookmarkService} from '../../services/proverb/proverb-bookmark.service';
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {BookmarkChange} from "../../defines/client.const";

@Component({
  selector: 'app-proverb-detail',
  styleUrls: ['./proverb-detail.component.scss'],
  template: `
    <div *ngIf="proverb"
         class="item-head-box">
      <app-link-content *ngIf="selected"
                        class="head-box"
                        [content]="proverb.proverb3 | resize"></app-link-content>
      <div *ngIf="!selected"
           class="head-box"
           [innerHTML]="proverb.proverb2 | resize | keepHtml"></div>
      <div *ngIf="selected"
           class="option-list">
        <div class="option-box">
          <!-- #452: 속담 책갈피 기능은 임시 비활성화. 재활성화할 수 있도록 토글 버튼 코드는 보존한다.
          <article class="bookmark-btn-box">
            <a class="bookmark-btn {{ getBmCss(proverb) }}"
               (click)="ToggleBookmark($event, proverb)"></a>
          </article>
          -->
        </div>
      </div>
    </div>

    <div *ngIf="proverb"
         class="item-body-box">
      <app-link-content *ngIf="selected"
                        class="des-box"
                        [content]="proverb.meaning3 | resize">
      </app-link-content>
      <div *ngIf="!selected"
           class="des-box"
           [innerHTML]="proverb.meaning2 | resize | keepHtml"></div>
    </div>
  `,
})
export class ProverbDetailComponent implements AfterViewInit {
  @HostBinding('class') class = 'item-box';
  @HostBinding('style.display') styleBlock = 'block';
  @Input() proverb: Proverb | undefined;
  /** 선택 상태 — true이면 링크 동작 활성화, false이면 읽기 전용 (기본값 true: 기존 소비자 역호환) */
  @Input() selected = true;
  /** 상세 표시 상태 — true이면 본문 말줄임을 풀고 글자 크기를 상세용으로 확대한다. */
  @HostBinding('class.expanded')
  @Input() expanded = false;
  @Output() viewInit = new EventEmitter<Proverb>();
  @Output() bookmarkChange = new EventEmitter<BookmarkChange>();

  private sendingBookmark = false;


  constructor(
    private bmSvc: ProverbBookmarkService,
    private globalEventSvc: GlobalEventService,
  ) {
  }

  ngAfterViewInit() {
    this.viewInit.emit(this.proverb);
  }

  public ToggleBookmark(event: MouseEvent, proverb: Proverb): void {
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event, true);

    if (this.sendingBookmark) {
      return; // 이미 보내고 있다.
    }
    this.sendingBookmark = true;
    proverb.bookmark = !proverb.bookmark;
    this.bmSvc.sendBookmark(proverb.id, proverb.bookmark).pipe(
      finalize(() => this.sendingBookmark = false)
    ).subscribe(
      data => {
        // console.warn('ProverbDetailComponent::ToggleBookmark() data = ', data);
        this.bookmarkChange.emit({id: proverb.id, bookmark: proverb.bookmark});
      },
      err => {
        console.error('ProverbDetailComponent::ToggleBookmark() failed', proverb.id, err);
        proverb.bookmark = !proverb.bookmark;
      }
    );
  }

  public getBmCss(proverb: Proverb): string {
    if (this.sendingBookmark) {
      return 'ing';
    }
    return proverb.bookmark ? 'on' : '';
  }

}
